/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Red_Wolf_LeapInputs */

const en_warm_red_wolf_leap = /** @type {(inputs: Warm_Red_Wolf_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum answers`)
};

const de_warm_red_wolf_leap = /** @type {(inputs: Warm_Red_Wolf_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestantworten`)
};

/**
* | output |
* | --- |
* | "Minimum answers" |
*
* @param {Warm_Red_Wolf_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_red_wolf_leap = /** @type {((inputs?: Warm_Red_Wolf_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Red_Wolf_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_red_wolf_leap(inputs)
	return de_warm_red_wolf_leap(inputs)
});